// extracted by mini-css-extract-plugin
module.exports = {"link":"hf154y","image":"Ym8oyT"};